import React from 'react';
import SummaryCard from './SummaryCard';

function Assumptions({ assumptions }) {
    const economic = assumptions?.economic || [];
    const personal = assumptions?.personal || [];

    return (
        <SummaryCard title="Assumptions">
            {/* Economic Assumptions */}
            <div className="mb-6">
                <div className="flex items-center gap-2 mb-4">
                    <span className="text-gray-600 text-lg">📊</span>
                    <h4 className="content-text font-medium text-gray-900">Economic Assumptions</h4>
                </div>

                <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                    {economic.map((item, idx) => (
                        <div key={item.label} className="flex flex-col">
                            <span className="content-text text-gray-500 text-sm mb-1">
                                {item.label}
                            </span>
                            <span className="content-text font-medium text-gray-900">
                                {item.value}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            {/* Border separator */}
            <div className="border-b border-gray-200 my-6"></div>

            {/* Personal Assumptions */}
            <div>
                <div className="flex items-center gap-2 mb-4">
                    <span className="text-gray-600 text-lg">🌱</span>
                    <h4 className="content-text font-medium text-gray-900">Personal Assumptions</h4>
                </div>

                <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                    {personal.map((item, idx) => (
                        <div key={item.label} className="flex flex-col">
                            <span className="content-text text-gray-500 text-sm mb-1">
                                {item.label}
                            </span>
                            <span className="content-text font-medium text-gray-900">
                                {item.value}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </SummaryCard>
    );
}

export default Assumptions;